module.exports = __webpack_public_path__ + "static/media/loader.2f32fc30.svg";